module.exports = __webpack_public_path__ + "static/img/banner-swiper1.c2862e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-swiper1.jpg
// module id = vAi6
// module chunks = 16